import { Box, CircularProgress, Image } from "@chakra-ui/react"

import banIcon from "#/assets/ban.svg"
import checkIcon from "#/assets/check-black.svg"
import { ConnectionStatus } from "#/shared/types"

type ConnectWalletStatusIconProps = {
  connectionStatus: ConnectionStatus
}

function DoneIcon() {
  return <Image src={checkIcon} />
}

function PendingIcon() {
  return (
    <CircularProgress
      isIndeterminate
      color="primary.red.100"
      trackColor="transparent"
      size="16px"
      thickness="12px"
    />
  )
}

function IdleIcon() {
  return <Box w="16px" h="16px" />
}

function ErrorIcon() {
  return <Image src={banIcon} />
}

export default function ConnectWalletStatusIcon({
  connectionStatus,
}: ConnectWalletStatusIconProps) {
  switch (connectionStatus) {
    case "idle":
      return <IdleIcon />
    case "pending":
      return <PendingIcon />
    case "done":
      return <DoneIcon />
    case "error":
      return <ErrorIcon />
    default:
      return <IdleIcon />
  }
}
